import React from "react";

function SortableHeaderCell({ columnKey, label, currentSort, onSort }) {

  function getHeaderLabel() {
    if (currentSort.key === columnKey) {
      if (currentSort.direction === 'ascending') return <>{label} <strong>↑</strong></>;
      if (currentSort.direction === 'descending') return <>{label} <strong>↓</strong></>;
    }
    return label;
  };

  return (
    <th onClick={() => onSort(columnKey)}>
      {getHeaderLabel()}
    </th>
  );
};

export default SortableHeaderCell;